"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ExplainDataIcon = function (props) { return (
// tslint:disable:max-line-length
// <?xml version="1.0" encoding="UTF-8"?>
React.createElement("svg", __assign({ width: '18', height: '18', viewBox: '0 0 18 18' }, props),
    React.createElement("path", { fill: '#666', fillRule: 'evenodd', d: 'M13,22 L13,23 L11,23 L11,22 L13,22 Z M14,20 L14,21 L10,21 L10,20 L14,20 Z M12,1 C16.0009061,1 20,4.00261412 20,9 C20,13.8838089 16.1797521,15.4927452 16.0061044,16.4352895 L16,16.5 L16,18.0278142 C15.9982106,18.5406469 15.6107029,18.9619732 15.1131663,19.0180085 L14.9965225,19.0243306 L8.99243763,19.0034512 C8.44251445,19.0015389 7.99733504,18.5559354 7.99591824,18.0060107 L8,16.4285714 L8,16.4285714 C8.0096062,15.6289165 4,13.853305 4,9 C4,4.146695 7.9990939,1 12,1 Z M12,2 C8.22970317,2 5,5.00026956 5,9 C5,10.733434 5.55223847,12.1030474 6.56037012,13.3431498 L6.75471379,13.5742085 C6.60920401,13.406821 9.00907158,15.6794262 8.99992785,16.4405835 L8.99563965,17.1045682 L8.99591492,18.0034344 L15,18.0243367 L15,16.5 C15,15.9386211 15.2203434,15.6092645 15.7870396,15.0554113 L16.5725184,14.3132547 C16.8289857,14.066653 17.0456616,13.8438883 17.2500986,13.6121482 C18.3817903,12.3293159 19,10.9043116 19,9 C19,4.90736961 15.8293171,2 12,2 Z' }))
// tslint:enable:max-line-length
); };
exports.ExplainDataIcon = ExplainDataIcon;
//# sourceMappingURL=ExplainDataIcon.js.map